import { strictify } from '~/utils/strictify'
import {
  TwoFactorTestAssistChallengeCodeHeaderSchema,
  TwoFactorTestAssistChallengeCodeSuccessSchema,
  TwoFactorTestAssistStepUpCodeSuccessSchema
} from '~/services/api/generated'

/** API test-assist routes; they exist only on local, testing, development, and qa deployments. */
export function useTestAssistService() {
  const baseURL = `${useRuntimeConfig().public.apiBaseUrl}/api`
  const sanctumClient = useApiRequest()

  /** The current code for a pending login two-factor challenge. */
  async function getChallengeCode(challengeToken: string) {
    const headers = TwoFactorTestAssistChallengeCodeHeaderSchema.parse({
      'X-Challenge-Token': challengeToken
    })
    return strictify(TwoFactorTestAssistChallengeCodeSuccessSchema).parse(
      await sanctumClient(`${baseURL}/test-assist/two-factor-code/challenge`, {
        method: 'GET',
        headers
      })
    ).data
  }

  /** The current code for the authenticated user's step-up confirmation. */
  async function getStepUpCode() {
    return strictify(TwoFactorTestAssistStepUpCodeSuccessSchema).parse(
      await sanctumClient(`${baseURL}/test-assist/two-factor-code/step-up`, { method: 'GET' })
    ).data
  }

  return { getChallengeCode, getStepUpCode }
}
